import type { Prospect } from './contract'
import { decisionOf } from './engine'

/* Rede — utilidades de tela comuns aos três tipos. */

/** "2026-10-21" -> "21/10/2026". */
export const brDate = (iso: string | null | undefined) => (iso && /^\d{4}-\d{2}-\d{2}/.test(iso) ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : '—')

/** Iniciais: tira "Igreja/Paróquia/Comunidade/Assembleia (de/do/da)", "Pr./Pra./Pe.", pega 2 palavras com mais de 2 letras. */
export function initialsOf(name: string): string {
    const clean = name
        .replace(/^(pr|pra|pe|rev)\.\s+/i, '')
        .replace(/^(igreja|par[oó]quia|comunidade|assembleia)(\s+(de|do|da|dos|das))?\s+/i, '')
    const words = clean.split(/\s+/).filter(w => w.length > 2)
    return ((words[0]?.[0] ?? '') + (words[1]?.[0] ?? '')).toUpperCase() || (name[0] ?? '?').toUpperCase()
}

/** Cores dos avatares por posição (tons do panel). */
const AVATAR = [
    { bg: 'var(--tint)', fg: 'var(--green)' },
    { bg: 'color-mix(in srgb, var(--yellow) 22%, var(--panel))', fg: 'var(--text)' },
    { bg: 'color-mix(in srgb, #3B5BA9 16%, var(--panel))', fg: '#3B5BA9' },
    { bg: 'color-mix(in srgb, #C0532B 14%, var(--panel))', fg: '#A33714' },
    { bg: 'color-mix(in srgb, #8E5BB5 14%, var(--panel))', fg: '#6E3F95' },
]
export const avatarColors = (index: number) => AVATAR[Math.abs(index) % AVATAR.length]!

/** "1,2 mi", "17 mi", "216 mil", "921"; 0 ou vazio = "—". */
export function fmtAudience(n: number | null | undefined): string {
    if (!n) return '—'
    if (n >= 1e6) {
        const v = n / 1e6
        return `${v >= 10 ? Math.round(v) : v.toFixed(1).replace(/\.0$/, '').replace('.', ',')} mi`
    }
    if (n >= 1e3) return `${Math.round(n / 1e3)} mil`
    return String(n)
}

export const counts = (items: Prospect[]) => ({
    undecided: items.filter(p => decisionOf(p) === 'undecided').length,
    approved: items.filter(p => decisionOf(p) === 'approved').length,
    rejected: items.filter(p => decisionOf(p) === 'rejected').length,
    inJourney: items.filter(p => p.pipe && p.pipe.st !== 'recusou').length,
    waiting: items.filter(p => p.pipe?.st === 'aguardando').length,
    approach: items.filter(p => p.pipe?.st === 'abordagem').length,
    active: items.filter(p => p.pipe?.st === 'ativo').length,
})
